////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const usersManager = {
	getAdminUsers: (
		filters = {},
		queryParam = {
			page: '0',
			size: '250',
			sort: 'companyTyped.company.labelToDisplay',
			nameDir: 'asc',
			sort_2: 'companyTyped.companyType.translationKey',
			nameDir_2: 'asc',
			sort_3: 'lastName',
			nameDir_3: 'asc',
		}
	) => ({
		type: ActionsTypes.GET_ADMIN_USERS,
		payload: { filters, queryParam },
	}),
	getAdminUsersSuccess: (adminUser) => ({
		type: ActionsTypes.GET_ADMIN_USERS_SUCCESS,
		payload: {
			adminUser,
		},
	}),
	getAdminUsersFailure: (error) => ({
		type: ActionsTypes.GET_ADMIN_USERS_FAILURE,
		payload: {
			error,
		},
	}),
	getUserDetail: (idUser) => ({
		type: ActionsTypes.GET_USER_DETAIL,
		payload: { idUser },
	}),
	getUserDetailSuccess: (userDetail) => ({
		type: ActionsTypes.GET_USER_DETAIL_SUCCESS,
		payload: {
			userDetail,
		},
	}),
	getUserDetailFailure: (error) => ({
		type: ActionsTypes.GET_USER_DETAIL_FAILURE,
		payload: {
			error,
		},
	}),
	postUserCreate: (user) => ({
		type: ActionsTypes.POST_USER_CREATE,
		payload: {
			user,
		},
	}),
	postUserCreateSuccess: (user) => ({
		type: ActionsTypes.POST_USER_CREATE_SUCCESS,
		payload: { user },
	}),
	postUserCreateFailure: (error) => ({
		type: ActionsTypes.POST_USER_CREATE_FAILURE,
		payload: { error },
	}),
	updateUserDetail: (user, idUser) => ({
		type: ActionsTypes.UPDATE_USER_DETAIL,
		payload: {
			user,
			idUser,
		},
	}),
	updateUserDetailSuccess: (user) => ({
		type: ActionsTypes.UPDATE_USER_DETAIL_SUCCESS,
		payload: { user },
	}),
	updateUserDetailFailure: (error) => ({
		type: ActionsTypes.UPDATE_USER_DETAIL_FAILURE,
		payload: { error },
	}),

	deleteAdminUser: (idUser, scope, redirectRequest = false) => ({
		type: ActionsTypes.DELETE_ADMIN_USER,
		payload: {
			idUser,
			scope,
			redirectRequest,
		},
	}),
	deleteAdminUserSuccess: (adminUser, idUser, scope) => ({
		type: ActionsTypes.DELETE_ADMIN_USER_SUCCESS,
		payload: {
			adminUser,
			idUser,
			scope,
		},
	}),
	deleteAdminUserFailure: (error) => ({
		type: ActionsTypes.DELETE_ADMIN_USER_FAILURE,
		payload: {
			error,
		},
	}),
	UserDetailResetPassword: (idUser) => ({
		type: ActionsTypes.USER_DETAIL_RESET_PASSWORD,
		payload: {
			idUser,
		},
	}),
	UserDetailResetPasswordSuccess: (response) => ({
		type: ActionsTypes.USER_DETAIL_RESET_PASSWORD_SUCCESS,
		payload: { response },
	}),
	UserDetailResetPasswordFailure: (error) => ({
		type: ActionsTypes.USER_DETAIL_RESET_PASSWORD_FAILURE,
		payload: { error },
	}),
	resetUserDetail: () => ({
		type: ActionsTypes.RESET_USER_DETAIL,
	}),

	setUserLogin: (userLogin) => ({
		type: ActionsTypes.SET_USER_LOGIN,
		payload: { userLogin },
	}),
	resetDataUsersManager: () => ({
		type: ActionsTypes.RESET_DATA_USERS_MANAGER,
	}),
}

export default usersManager
